module.exports = __webpack_public_path__ + "img/Back.bb145a95.svg";